var lib_core = require("lib-core");

var ComposedSymbolData = function () {
    var self = this;
    this.makeObservableTreeNode();

    this.symbolInstances = this.set("symbolInstances", true);

    this.symbolInstanceNames = new lib_core.NameManager();    // TODO: current namelist should become a shadow, which can be used by the validators and proposal get
    var uniqueNameValidator = function(name){
        return name != undefined && !self.symbolInstanceNames.isRegistered('', name);
    };
    this.symbolInstances.onAdd("nameManager", function(symbolInstance){
        if (self.symbolInstanceNames.isRegistered('', symbolInstance.name())) symbolInstance.name(self.symbolInstanceNames.getProposal('', symbolInstance.name())); // if name of added symbolInstance already exist propose a new unique name
        self.symbolInstanceNames.register('', symbolInstance.name());
        symbolInstance.name.onChange("nameManager", function(name, old){
            self.symbolInstanceNames.remove('', old);
            self.symbolInstanceNames.register('', name);
        });
        symbolInstance.name.validator = uniqueNameValidator;
    });
    this.symbolInstances.onRemove("nameManager", function(symbolInstance){
        self.symbolInstanceNames.remove('', symbolInstance.name());
        symbolInstance.name.removeHandlers("nameManager");
        symbolInstance.name.validator = null;
    });

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            var boundingBox = null;
            this.symbolInstances.forEach(function(symbolInstance) {
                var bb = symbolInstance.boundingBox();
                boundingBox = bb.merge(boundingBox);
            });
            return boundingBox;
        },
        [this.symbolInstances]
    );
};
lib_core.mixin(ComposedSymbolData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(ComposedSymbolData, "ComposedSymbolData");
module.exports = ComposedSymbolData;

ComposedSymbolData.prototype.getSnapElements = function () {
    var result = new lib_core.Collections.HashSet();
    result.addAll(this.symbolInstances);
    return result;
};
